(function ($) {
    //Eliminar código HTML de una cadena
    function stripHtml(html)
    {
        let tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    //Función para formatear pasar un nombre completo a sus dos primeras palabras, con guiones por espacios, sin mayúsculas ni caracteres raros
    //Actualizado a tomar las palabras segunda y tercera (por la inclusión de Dr/Dra) y limpiar espacios extraños (trim()) 
    function nameSur(nameSurname){
        var noDots = nameSurname.split('.').join("").trim();
        var twoFirstWords = noDots.split(' ').slice(1,3).join(' ');
        var noSpacesNoUppercase = twoFirstWords.replace(/\s+/g, '-').toLowerCase();
        var noWeirdCharacters = noSpacesNoUppercase.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return noWeirdCharacters;
    }
    /*
    function nameSur(nameSurname){
        var noDots = nameSurname.split('.').join("");
        var twoFirstWords = noDots.split(' ').slice(0,2).join(' ');
        var noSpacesNoUppercase = twoFirstWords.replace(/\s+/g, '-').toLowerCase();
        var noWeirdCharacters = noSpacesNoUppercase.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return noWeirdCharacters;
    }
    */

    //Para añadir el nombre del líder del elemento del listado al link como hash en la lista de Research Programmes
    const elements = document.querySelectorAll('.view-research-programmes .views-row');
    Array.prototype.forEach.call(elements, function(element, index) {
      var spanText = stripHtml(element.getElementsByTagName("span")[0].innerHTML);
      var nameSurname = nameSur(spanText);
      var url = element.getElementsByTagName("a")[0];
      var href = url.getAttribute("href");
      url.setAttribute("href",href+"#"+nameSurname);
    });

    $('.tab-pane').each(function () {
      var coordinator = $(this).find('span.research-group-coordinator-name').text().trim();
      if (coordinator != ""){
        $(this).find(".view-research-groups .views-row:contains("+ coordinator +")").hide();
      }
    });

})(jQuery, Drupal);